import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MainHeaderComponentGeneric } from './main-header';
import { CmsModule, CmsLinkEmbededModuleGeneric } from '@signature-it/ngx-generic/components/cms';
import { UserLoginModuleGeneric } from '@signature-it/ngx-generic/components/user-login';
import { MainHeaderSearchFormModuleGeneric } from '@signature-it/ngx-generic/components/search-form';
import { PhoneOrderModule } from '@signature-it/ngx-generic/components/phone-order';
import { MainHeaderNavbarMobileModuleGeneric } from '@signature-it/ngx-generic/components/navbar-mobile';
import { MainTopNavigationModuleGeneric } from '@signature-it/ngx-generic/components/top-navigation';
import { DropdownLangsModuleGeneric } from '@signature-it/ngx-generic/components/languages';
import { GroupsMenuModuleGeneric } from '@signature-it/ngx-generic/components/groups-menu';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        CmsModule,
        MainTopNavigationModuleGeneric,
        DropdownLangsModuleGeneric,
        UserLoginModuleGeneric,
        MainHeaderSearchFormModuleGeneric,
        MainHeaderNavbarMobileModuleGeneric,
        CmsLinkEmbededModuleGeneric,
        PhoneOrderModule,
        GroupsMenuModuleGeneric
    ],
    declarations: [MainHeaderComponentGeneric],
    exports: [MainHeaderComponentGeneric]
})
export class MainHeaderModuleGeneric {}
